import { kUserFilesApiBasePath } from '@/constants/constants-api-paths'
import { kUserFilesDeleteSelectionMaxFileIds, kUserFilesDeleteSelectionMaxFolderIds } from '@/user_files/limits'

export const kUserFilesDeleteApiBasePath = `${kUserFilesApiBasePath}/delete`

// Backend request limits
export const kDeleteMaxFileIdsPerRequest = kUserFilesDeleteSelectionMaxFileIds
export const kDeleteMaxFolderIdsPerRequest = kUserFilesDeleteSelectionMaxFolderIds
